import './style.scss'
import Layer from '../Layer'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Button from '../Form/Button'
import { ReactComponent as ShinyIcon } from '../../../assets/img/icons/shiny-new-sparkle.svg'
import { ReactComponent as CloseIcon } from '../../../assets/img/icons/close.svg'
import classNames from 'classnames'

const GenericModal = ({
                        id,
                        show,
                        onClose,
                        title,
                        subtitle,
                        body,
                        icon,
                        iconPlacement = 'left',
                        showCloseButton = false,
                        closeButtonLabel = 'Close',
                        actions,
                        buttonsCentered = true,
                        maxWidth,
                        background = 'white',
                        borderRadius = '20px',
                        className,
                      }) => {
  const { t } = useTranslation()
  const hasIcon = icon !== null
  return (
    <Layer
      type="center"
      size="small"
      id={id}
      show={show}
      onHideClick={onClose}
      background={background}
      borderRadius={borderRadius}
      showCloseIcon={false}
      className={classNames('generic-overlay', className)}
      closeOnEsc={true}
      maxWidth={maxWidth}
    >
      {showCloseButton && (
        <button
          type="button"
          className="generic-overlay__close"
          aria-label={closeButtonLabel}
          onClick={onClose}
        >
          <CloseIcon/>
        </button>
      )}
      <div
        className={classNames(
          'generic-overlay__header',
          `generic-overlay__header--icon-${iconPlacement}`,
        )}
      >
        {hasIcon && (
          <span className="generic-overlay__icon" aria-hidden="true">
            {icon || <ShinyIcon/>}
          </span>
        )}
        <div className="generic-overlay__content">
          <div className="generic-overlay__title-group">
            <h2 className="generic-overlay__title">{title}</h2>
            {subtitle && <p className="generic-overlay__subtitle">{subtitle}</p>}
          </div>
          {body && <div className="generic-overlay__body">{body}</div>}
        </div>
      </div>
      {actions && actions.length > 0 && (
        <div
          className={
            classNames(
              'generic-overlay__footer', {
                'generic-overlay__footer--centered': buttonsCentered,
              }
            )
          }
        >
          {actions.map((action) => (
            <Button
              key={action.label}
              onClick={action.onClick}
              variant={action.variant}
              minWidth={action.minWidth}
              disabled={action.disabled}
            >
              {t(action.label)}
            </Button>
          ))}
        </div>
      )}
    </Layer>
  )
}

GenericModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  body: PropTypes.node,
  /** Custom icon node. Pass `null` to hide the icon entirely; omit to use the default. */
  icon: PropTypes.node,
  iconPlacement: PropTypes.oneOf(['left', 'top']),
  showCloseButton: PropTypes.bool,
  closeButtonLabel: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    variant: PropTypes.string,
    minWidth: PropTypes.string,
    disabled: PropTypes.bool,
  })),
  buttonsCentered: PropTypes.bool,
  id: PropTypes.string.isRequired,
  maxWidth: PropTypes.string,
  background: PropTypes.string,
  borderRadius: PropTypes.string,
  className: PropTypes.string,
}

GenericModal.defaultProps = {
  actions: [],
}

export default GenericModal
